<template>
    <common-modal
        v-if="showContactCollector"
        :showAsInnerModal="showAsInnerModal"
        class="contact-collector_modal"
        width="small"
        height="extra-small"
        @close="close()"
    >
        <common-content-wrapper width="medium">
            <common-content-spacer height="tiny" class="contact-collector__container">
                <common-page-header
                    :heading="$t('elements.network.contact_collector.heading')"
                    size="medium"
                    :isCenter="true"
                ></common-page-header>
                <div v-if="showSearchBar" class="tracking-controls__filters form-input-text">
                    <text-input
                        v-model="searchQuery"
                        :placeholder="$t('elements.network.contact_collector.placeholder')"
                        type="text"
                        @change="searchUser($event)"
                    ></text-input>
                    <common-icon class="tracking-controls__filters--search" name="search-gray" size="huge"></common-icon>
                </div>
                <div class="contact-collector__contacts-container">
                    <common-content-spacer
                        v-for="(contact, index) in contacts"
                        :key="index"
                        height="small"
                        :class="[
                            'contact-collector__contact-row',
                            { 'contact-collector__hide-contact': !isContactInSearchQuery(contact.name) },
                        ]"
                    >
                        <common-icon
                            :name="isContactSelected(index) ? 'checkbox-on' : 'checkbox-off'"
                            size="large"
                            class="contact-collector__select-contact-checkbox"
                            @click="selectThisContact(index)"
                        ></common-icon>
                        <div class="form-input-toggle__option"></div>
                        <div class="contact-collector__contact-images" @click="selectThisContact(index)">
                            <common-user-avatar
                                v-if="!contact.image && contact.name"
                                class="contact-collector__contact-image"
                                size="small"
                                :user="{ name: contact.name }"
                                :isUserProfileLinkEnabled="false"
                            ></common-user-avatar>
                            <img
                                v-if="contact.image"
                                :src="contact.image"
                                :alt="contact.name"
                                class="contact-collector__contact-image"
                            />
                        </div>
                        <common-content-wrapper width="medium">
                            <p :key="index" class="contact-collector__contact-name" @click="selectThisContact(index)">
                                {{ contact.name }}
                            </p>
                            <div>
                                <common-content-spacer height="micro">
                                    <p
                                        v-for="(email, i) in contact.emails"
                                        :key="i"
                                        :class="[
                                            {
                                                'contact-collector__email-selected':
                                                    isEmailSelected(index, i) && contactHasMultipleEmails(index),
                                            },
                                            'contact-collector__contact-email',
                                        ]"
                                        @click="selectEmail(index, i)"
                                    >
                                        {{ email.email }}
                                        <common-icon
                                            v-if="contactHasMultipleEmails(index) && isEmailSelected(index, i)"
                                            size="tiny"
                                            name="close"
                                            style="color: red"
                                        ></common-icon>
                                    </p>
                                </common-content-spacer>
                            </div>
                        </common-content-wrapper>
                    </common-content-spacer>
                </div>
                <div>
                    <common-warning v-if="showWarning" size="medium" :text="warningText"></common-warning>
                </div>
                <common-content-spacer class="contact-collector__add-contacts-button" height="micro">
                    <common-button
                        :label="buttonLabel"
                        type="primary"
                        :isSubmittable="true"
                        :isDisabled="isDisabled()"
                        @click="collectContacts"
                    ></common-button>
                </common-content-spacer>
            </common-content-spacer>
        </common-content-wrapper>
    </common-modal>
</template>
<script>
    import TextInput from '../../form-inputs/TextInput.vue'
    import debounce from 'lodash.debounce'
    import cloneDeep from 'lodash.clonedeep'
    import config from '../../../config'

    export default {
        components: {
            TextInput,
        },
        props: {
            contactsProp: { type: Array, required: true },
            showAsInnerModal: { type: Boolean, required: false, default: false },
            showContactCollector: { type: Boolean, required: true },
            buttonLabel: { type: String, required: true },
            showSearchBar: { type: Boolean, required: false, default: true },
            prefillUser: { type: String, required: false, default: '' },
            maxSelectedContacts: { type: Number, required: false, default: 25 },
        },
        data() {
            return {
                selectedContacts: [],
                warningText: '',
                showWarning: false,
                searchQuery: this.prefillUser,
                contacts: [],
            }
        },
        methods: {
            selectEmail(index, i) {
                this.contacts[index].emails[i].selected = !this.contacts[index].emails[i].selected
                if (!this.selectedContacts.includes(index)) {
                    this.selectedContacts.push(index)
                } else {
                    const anySelected = !!this.contacts[index].emails.find((email) => email.selected)
                    if (!anySelected) {
                        this.selectedContacts = this.selectedContacts.filter((c) => c !== index)
                    }
                }
            },
            contactHasMultipleEmails(index) {
                return this.contacts[index].emails.length > 1
            },
            isEmailSelected(index, i) {
                return this.contacts[index].emails[i].selected
            },
            isContactSelected(index) {
                return this.selectedContacts.includes(index)
            },

            async selectThisContact(index) {
                if (!this.selectedContacts.includes(index)) {
                    this.selectedContacts.push(index)
                    this.selectEmail(index, 0)
                } else {
                    this.selectedContacts = this.selectedContacts.filter((c) => c !== index)
                    this.contacts[index].emails.forEach((email, i) => {
                        this.contacts[index].emails[i].selected = false
                    })
                }
            },

            searchUser: debounce(function (search) {
                this.searchQuery = search.trim()
            }, config.DEBOUNCE.DEFAULT),

            close() {
                this.showWarning = false
                this.searchQuery = ''
                this.selectedContacts = []
                this.emitEvent({ name: 'close' })
            },

            collectContacts() {
                if (this.maxSelectedContacts !== 0 && this.selectedContacts.length > this.maxSelectedContacts) {
                    this.showWarning = true
                    this.warningText = this.$t('modals.contact_collector.warning_message', { message: this.maxSelectedContacts })
                    return
                }
                if (this.maxSelectedContacts === 0 || this.selectedContacts.length <= this.maxSelectedContacts) {
                    this.emitEvent({ name: 'selected-contacts', payload: this.filterSelectedContactsEmails() })
                    this.selectedContacts = []
                    this.showWarning = false
                }
            },

            filterSelectedContactsEmails() {
                let contacts = this.contacts.filter((c, index) => this.selectedContacts.includes(index))
                return contacts
            },

            isDisabled() {
                return this.selectedContacts.length === 0
            },

            isContactInSearchQuery(name) {
                return name.toLowerCase().includes(this.searchQuery.toLowerCase())
            },
        },

        watch: {
            contactsProp() {
                this.contacts = cloneDeep(this.contactsProp)
            },
        },
    }
</script>
